import config from '../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/connector';

export const connectorService = {
  getAll,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}
